import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'filter-by-letter',
    templateUrl: './filter-by-letter.component.html',
    styleUrls: ['./filter-by-letter.component.scss'],
})
export class FilterByLetterComponent {
    @Input() activeLetter = '';
    @Output() selectedLetter = new EventEmitter<string>();

    filterLetterRows = [
        ['0-9', 'A', 'B', 'C', 'D', 'E'],
        ['F', 'G', 'H', 'I', 'J', 'K'],
        ['L', 'M', 'N', 'O', 'P', 'Q'],
        ['R', 'S', 'T', 'U', 'V', 'W'],
        ['X', 'Y', 'Z'],
    ];

    clickFilterLetter(letter: string) {
        this.selectedLetter.emit(this.activeLetter === letter ? '' : letter);
    }
}
